var __jsx = React.createElement;
import React from 'react';
import Link from 'next/link';
import styles from '../../styles/rca/rca.module.scss';

var RCALegalNotice = function RCALegalNotice() {
  return __jsx("div", {
    className: "".concat(styles.boxWrapper, " mb-5 text-left")
  }, __jsx("p", {
    className: "".concat(styles.boxCategory)
  }, "Termeni legali"), __jsx("p", {
    className: styles.info
  }, "Asigurarile RCA cumparate online pe Conso sunt emise in numele societatilor de asigurare de catre Conso Media Group SRL societate cu raspundere limitata, cu sediul in Str. Dr. Nicolae Tomescu nr. 11, Ap. 1, Sector 5, cod postal: 050595, Bucuresti, inregistrata in Registrul Intermediarilor in Asigurari si/sau Reasigurari sub numarul RAJ 500426, in calitate de asistent in brokeraj al CAMPION BROKER DE ASIGURARE SI REASIGURARE SRL \u2013 intermediar principal in asigurari, mandatat de catre societatile de asigurare, cu sediul in Ploiesti, str 1 Mai, nr.2, ap.2, judet Prahova, inscrisa in Registrul Brokerilor de Asigurare nr. RBK -324/24.11.2005, cu autorizatie de functionare nr. 3963/23.11.2005. Pentru mai multe detalii, citeste ", __jsx(Link, {
    href: "".concat(process.env.NEXT_PUBLIC_WEB, "/termeni/asigurari")
  }, __jsx("a", {
    title: "Termeni contracte de asigurare RCA",
    target: "_blank"
  }, "Termenii contractelor de asigurare RCA")), "."));
};

export default RCALegalNotice;